import React, { forwardRef } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LanguageFlag from '@components/LanguageFlag';
import { selectLanguages } from '@redux/core/reducers';
import './style.less';

const { Option } = Select;

// for use with getFieldDecorator
function LanguageSelect({ disabled, value, onChange }, ref) {
  const { t } = useTranslation();
  const languages = useSelector(selectLanguages);

  return (
    <Select
      className="language-select-option"
      disabled={disabled}
      placeholder={t('common:LanguageSelect.placeholder')}
      ref={ref}
      value={value}
      onChange={onChange}
    >
      {Object.values(languages).map(({ icon, key, name }) => (
        <Option className="language-select-option" key={key} value={key}>
          <span className="language-flag-label">
            <LanguageFlag icon={icon} />
            {t(name)}
          </span>
        </Option>
      ))}
    </Select>
  );
}

export default forwardRef(LanguageSelect);
